import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon, grey600 } from '@paypalcorp/pp-react';

function SocialShareEmail({ url, handleAnalytics }) {
  return (
    <Link
      href={url}
      onClick={() => handleAnalytics('email-share')}
      style={{ color: grey600 }}
      data-testid="social-share-email"
    >
      <Icon name="share-email" className="ppvx_icon--size_lg" />
    </Link>
  );
}

SocialShareEmail.propTypes = {
  url: PropTypes.string,
  handleAnalytics: PropTypes.func,
};

export default SocialShareEmail;
